import {SET_BET_LIST_FILTER} from "@actions/actionTypes";
import initialStore from "../../initialStore";

export default function BetsListFilterReducer(state = initialStore.emptyObj, action) {
    switch (action.type) {
        case SET_BET_LIST_FILTER:
            return action.filter
        default:
            return state;
    }
}
